import { TRUST_ITEMS } from "../../data/site";

function Track({ ariaHidden = false }) {
  return (
    <ul
      aria-hidden={ariaHidden || undefined}
      className="flex shrink-0 items-center gap-10 pr-10"
    >
      {TRUST_ITEMS.map((it) => (
        <li key={it.label} className="flex items-center gap-10 whitespace-nowrap">
          <span className="flex items-center gap-2.5 text-sm font-medium text-muted-foreground">
            <it.icon className="h-4 w-4 text-electric" strokeWidth={1.8} />
            {it.label}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 rounded-[2px] bg-border" aria-hidden="true" />
        </li>
      ))}
    </ul>
  );
}

export default function TrustMarquee() {
  return (
    <section className="border-y border-border bg-card/40 py-6" aria-label="Tecnología desarrollada para operaciones críticas" data-testid="trust-marquee">
      <div className="wrap">
        <p className="eyebrow">Tecnología desarrollada para operaciones críticas</p>
      </div>
      <div className="relative mt-5 flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
        <div className="flex animate-marquee">
          <Track />
          <Track ariaHidden />
        </div>
      </div>
    </section>
  );
}
